import React from 'react';

interface HowToUseProps {}

const data = [
    {
        instruction: `All SMS must contain the keyword “ASTRO”`,
    },
    {
        instruction: `Just enter the message you want to configure in the text box above. It will show you the number of
                    characters used and the message count.`,
    },
    {
        instruction: `Whenever you cross the number of characters that can be sent in 1 message, you will receive a warning -
                    “Caution! This text will be sent as ‘n’ messages.”`,
    },
    {
        instruction: `On the right side it will show the estimated cost of the message you are configuring. By entering the target
                    audience (number of people) you want to send this message, you will get an estimated cost.`,
    },
    {
        instruction: `Analyzing box will be appear when you start typing your message. The Analyzing box help you to specify the
                    character that you use in the message.`,
    },
    {
        instruction: `NOTE : The cost shown is indicative only - based on SMS tier cost and variable Telco charges.`,
    },
];

const HowToUse: React.FC<HowToUseProps> = () => {
    return (
        <React.Fragment>
            <h2 className='pb-4 text-base text-gray-600 font-semibold tracking-wide uppercase'>How to use</h2>
            <div>
                <dl className='space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10'>
                    {data.map((data, idx) => (
                        <div key={idx} className='relative'>
                            <dt>
                                <div className='mt-1 absolute flex items-center justify-center h-12 w-12 rounded-md bg-pink-600 text-white'>
                                    {idx + 1}
                                </div>
                                <p className='ml-16 text-sm leading-7 font-medium text-gray-900 text-justify'>{data.instruction}</p>
                            </dt>
                        </div>
                    ))}
                </dl>
            </div>
        </React.Fragment>
    );
};

export default HowToUse;
